var process = (typeof require != "undefined") ? require("process") : false;
var exec = (typeof require != "undefined") ? require('child_process').exec : false;
var printer = (process !== false && process.platform == 'osx') ? require("printer") : false;
var gui = (typeof require != "undefined") ? require('nw.gui') : false;

// Constructor
function Guichet(datafile) {
	this.lastClick = millis();
	this.resetDelay = 30000;
	// this.printerName = "";
	// this.printerName = "HP LaserJet P1005";
	this.printerName = "Epson TM-T88V Receipt";
	this.init();
	this.initEvents();

	//this.print("test.pdf");

	this.exec = exec;

}

Guichet.prototype.init = function () {
	setInterval($.proxy(function () {
		this.checkTimer();
	}, this), 1000);

	setInterval($.proxy(function () {
		this.initEvents();
	}, this), 5000);
}


Guichet.prototype.initEvents = function () {

	// Callbacks
	$("#game").off("mousedown touchstart").on("mousedown touchstart", ".option", $.proxy(function (e) {
		e.preventDefault();
		var screen = $(e.currentTarget).data("screen");
		var lang = $(e.currentTarget).data("lang");
		var filename = $(e.currentTarget).data("print");

		// Set language
		if (typeof lang != "undefined") {
			this.i18nSet(lang);
		}

		// Set screen
		this.gotoScreen(screen);

		// Print document
		if (typeof filename != "undefined") {
			console.log("print", filename);
			this.print(filename, 1, this.printerName);
		}

	}, this));

	// Timeout related
	$(document).off("click touchstart mousedown").on("click touchstart mousedown", $.proxy(function (e) {
		this.resetTimer();
	}, this));

	if (gui) {
		$(window).off("keydown").on('keydown', $.proxy(function (e) {
			this.keyPressed(e)
		}, this));
	}
}

Guichet.prototype.keyPressed = function (e) {

	if (e.keyCode == 80) {
		// P
		this.print("money20.pdf", 1, this.printerName);
	} else if (e.keyCode == 27) {
		// Escape
		gui.App.quit();
	} else if (e.keyCode == 73 || e.keyCode == 67) {
		// Key I or C
		gui.Window.get().showDevTools();
	}

}

// Select an option
Guichet.prototype.gotoScreen = function (screen) {
	$(".screen").removeClass("active");
	$("#" + screen).addClass("active");

	if (screen == "screen-2") {
		this.insertCard();
	}

	if (screen == "screen-1" || screen == "screen-intro") {
		this.removeCard();
	}

	if (screen == "screen-4C") {
		this.startGlowing();
		this.insertEnveloppe();
	} else {
		this.stopGlowing();
	}


};

// Insert card animation
Guichet.prototype.insertCard = function (el) {
	$("#card").transition({
		easing: "easeInOutQuad",
		duration: 800,
		top: 70,
		rotate: 0,
		left: 1456,
	})
};

// Insert card animation
Guichet.prototype.removeCard = function (el) {
	$("#card").transition({
		easing: "easeInOutQuad",
		duration: 650,
		top: 380,
		rotate: -75,
		left: 1506,
	})
};

// Insert enveloppe animation
Guichet.prototype.insertEnveloppe = function (el) {

	$("#enveloppe").css("top", 1080);
	$("#enveloppe").css("left", 1430);
	$("#enveloppe").css("rotate", -3);

	$("#enveloppe").transition({
		easing: "easeInOutQuad",
		duration: 1400,
		left: 1430,
		top: 250,
		rotate: 0,
	})
};

// Start deposit glowing
Guichet.prototype.startGlowing = function (el) {
	$("#glowing-deposit").transition({
		easing: "easeInOutQuad",
		duration: 250,
		opacity: 1,
	});
};

// Stop deposit glowing
Guichet.prototype.stopGlowing = function (el) {
	$("#glowing-deposit").transition({
		easing: "easeInOutQuad",
		duration: 250,
		opacity: 0,
	});
};

// Print file
Guichet.prototype.print = function (filename, copies, printerName) {

	if (process) {

		// Log platforrm
		// console.log(process.platform);

		if (printer) {
			printer.printFile({
				filename: "data/" + filename,
				printer: process.env[3], // printer name, if missing then will print to default printer
				success: function (jobID) {
					console.log("sent to printer with ID: " + jobID);
				},
				error: function (err) {
					console.log(err);
				}
			});

		} else {

			// executes `pwd`
			var cmd = '2printer -alerts_no -s \"' + process.cwd() + '/data/' + filename + '"';

			// Add printer name
			if (typeof printerName != "undefined" && printerName != "") {
				cmd += ' -prn "' + printerName + '"';
			}

			// Add copies count
			if (typeof filename != "undefined") {
				cmd += ' -copies ' + parseInt(copies);
			}

			console.log("EXECUTE: " + cmd);

			var child = exec(cmd, function (error, stdout, stderr) {
				console.log('stdout: ' + stdout);
				console.log('stderr: ' + stderr);
				if (error !== null) {
					console.log('exec error: ' + error);
				}
			});
		}
	}
};

Guichet.prototype.i18nSet = function (lang) {

	console.log(lang)

	if (lang == "fr") {
		this.lang = "fr";
		$("body").removeClass("i18n-en").addClass("i18n-fr");
	} else {
		this.lang = "en";
		$("body").removeClass("i18n-fr").addClass("i18n-en");
	}
}


Guichet.prototype.resetTimer = function (data) {
	this.lastClick = millis();
}

Guichet.prototype.checkTimer = function (data) {
	var noActionSince = millis() - this.lastClick;
	if (noActionSince > this.resetDelay) {
		this.reset();
	}
}

Guichet.prototype.reset = function () {
	this.lastClick = millis();
	this.gotoScreen("screen-intro");
	//this.clearInvoice();
};

// Expose Guichet
window.Guichet = Guichet;
